import { axiosGet } from "src/common/axios/axios-api-wrapper.hook";
import { getEECSApiForRegion } from "src/utils/utils";
import { isAftxDomain } from "src/utils/aftx-utils";
import { isFcMenuDomain } from "src/utils/fc-utils";

export interface FeaturesResponse {
    nodeId: string;
    enabledFeatures: string[];
    degraded?: boolean;
}

const isValidFeaturesResponse = (data: any): data is FeaturesResponse => {
    return (
        data !== null &&
        typeof data === "object" &&
        Array.isArray(data.enabledFeatures)
    );
};

/**
 * APIGW non-proxy or pass-through integrations sometimes wrap the lambda
 * payload as `{statusCode, body: "<json string>"}` or hand us a raw JSON
 * string. Normalize before validating.
 */
const unwrap = (raw: any): any => {
    if (raw == null) return raw;
    let candidate: any = raw;
    if (typeof candidate === "string") {
        try {
            candidate = JSON.parse(candidate);
        } catch {
            return raw;
        }
    }
    if (candidate && typeof candidate === "object") {
        if (typeof candidate.body === "string") {
            try {
                return JSON.parse(candidate.body);
            } catch {
                /* fall through */
            }
        }
        if (candidate.body && typeof candidate.body === "object") {
            return candidate.body;
        }
    }
    return candidate;
};

export const getFeaturesApi = async (): Promise<FeaturesResponse> => {
    const config = (isAftxDomain() || isFcMenuDomain()) ? { withCredentials: true } : {};
    // The shared response interceptor (response.handler.ts) returns
    // response.data on 200, so this resolves to the parsed body, not an
    // axios envelope.
    const body: any = await axiosGet(getEECSApiForRegion(), "features", config);
    const unwrapped = unwrap(body);
    if (!isValidFeaturesResponse(unwrapped)) {
        return { nodeId: "", enabledFeatures: [], degraded: true };
    }
    return unwrapped;
};
